





















































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import FieldImg from '@/app/components/Field/List/FieldImg.vue'
import Loading from '@/app/components/Common/Loading.vue'
/* module */
import { fieldDetailsData } from '@/app/model/store/domain/types'
import Session from '@/app/module/session'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    Loading,
    FieldImg
  }
})
export default class FieldItem extends Vue {
  private isModalActiveClass: boolean = false
  private isActiveSickness: boolean = false
  private isActiveWeeds: boolean = false
  private isActivePest: boolean = false
  private isActiveHumanProblem: boolean = false
  private isActiveWaterControl: boolean = false
  private fieldId: string = ''
  private detailsData: any = {
    area_name: '-',
    earth_temperature: '-',
    field_id: 0,
    grade: '-',
    growth_status: '-',
    harvest_forecast_days: 0,
    image_path: require('@/assets/icon/ico_barley_02.svg'),
    intergration_temperature: 0,
    lat: '',
    lng: '',
    max_intergration_temperature: 0,
    ph: '-',
    planting_id: 0,
    excluded_area_rate: null,
    risk: {
      sickness: false,
      weeds: false,
      pest: false,
      human_problem: false,
      water_control: false
    },
    season: '-',
    variety_id: 0,
    variety_name: '-'
  }
  private phIcon: string = require('@/assets/icon/ico_phmeter-54.svg')
  private earthIcon: string = require('@/assets/icon/ico_earthtemperature0-15.svg')
  private excludedAreaIcon: string = require('@/assets/icon/excluded_area_none.svg')
  private imgPath: string = ''
  private originalImgPath: string = require('@/assets/icon/ico_barley_02.svg')
  private maxIntegrationTemperature: number = 0
  private memori: number[] = []
  private oneMemoriWidth: number = 0
  private oneWidthTemperature:number = 0
  private showLoading: boolean = true
  private showNodata: boolean = true
  private showLackData: boolean = false
  private showFieldItem: boolean = false

  @Prop() private item!:any
  @Prop() private areaId!: number
  @Prop() private flag!: boolean // 圃場一覧画面かモーダルかのフラグ

  /* computed */
  private get modalFieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.modalId
  }
  private get detailsDataFlag (): boolean {
    return this.$store.state.setFlagState.modalFieldDetailsDataFlag
  }
  private get changeItem (): number {
    return this.item
  }

  @Watch('modalFieldChoiceState')
  ooModalIdChange (newValue: string) {
    if (newValue === this.item.id) {
      this.isModalActiveClass = true
    } else {
      this.isModalActiveClass = false
    }
  }
  @Watch('detailsDataFlag')
  getDetailsDataFlag (flag: boolean) {
    if (flag) {
      this.getFieldDetailsData()
    }
  }
  @Watch('changeItem')
  getItem () {
    if (this.item.id === this.$store.state.fieldChoiceState.modalId) {
      this.isModalActiveClass = true
    } else {
      this.isModalActiveClass = false
    }
    this.getFieldDetailsData()
  }

  created () {
    if (this.$store.state.setFlagState.modalFieldDetailsDataFlag) {
      this.getFieldDetailsData()
    } else {
      // 詳細データがない場合
      this.showLoading = false
    }

    if (this.item.id === this.$store.state.fieldChoiceState.modalId) {
      this.isModalActiveClass = true
    } else {
      this.isModalActiveClass = false
    }

    this.$store.commit('fieldChoiceState/setModalChooseFlag', false)
  }

  /* 圃場状態アイコンの判定 */
  private judgmentWorning () {
    if (this.detailsData.risk.sickness) {
      this.isActiveSickness = true
    } else {
      this.isActiveSickness = false
    }

    if (this.detailsData.risk.weeds) {
      this.isActiveWeeds = true
    } else {
      this.isActiveWeeds = false
    }

    if (this.detailsData.risk.pest) {
      this.isActivePest = true
    } else {
      this.isActivePest = false
    }

    if (this.detailsData.risk.human_problem) {
      this.isActiveHumanProblem = true
    } else {
      this.isActiveHumanProblem = false
    }

    if (this.detailsData.risk.water_control) {
      this.isActiveWaterControl = true
    } else {
      this.isActiveWaterControl = false
    }
  }

  private judgmentPhIcon () {
    if (this.detailsData.ph <= 6.0) {
      this.phIcon = require('@/assets/icon/ico_phmeter-54.svg')
    } else if (this.detailsData.ph >= 7.0) {
      this.phIcon = require('@/assets/icon/ico_phmeter59-.svg')
    } else {
      this.phIcon = require('@/assets/icon/ico_phmeter54-59.svg')
    }
  }

  private judgmentEarthIcon () {
    /* 地温閾値 */
    if (this.detailsData.earth_temperature <= 5) {
      this.earthIcon = require('@/assets/icon/ico_earthtemperature0-15.svg')
    } else if (this.detailsData.earth_temperature >= 35) {
      this.earthIcon = require('@/assets/icon/ico_earthtemperature35-.svg')
    } else {
      this.earthIcon = require('@/assets/icon/ico_earthtemperature15-35.svg')
    }
  }

  private displayExcludedArea () {
    if (this.detailsData.excluded_area_rate === 0) {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_blue.svg')
    } else if (this.detailsData.excluded_area_rate !== null && this.detailsData.excluded_area_rate < 20) {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_yellow.svg')
    } else if (this.detailsData.excluded_area_rate !== null && this.detailsData.excluded_area_rate >= 20) {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_red.svg')
    } else {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_none.svg')
    }
  }

  /* プログレスバーメモリ */
  private progressMemori () {
    this.oneWidthTemperature = this.maxIntegrationTemperature / 340
    this.oneMemoriWidth = 100 / this.oneWidthTemperature
    this.memori = []

    for (var i = 100; i < this.maxIntegrationTemperature; i += 100) {
      this.memori.push(i)
    }
  }

  private async getFieldDetailsData () {
    let detailsContent: any = await Session.getFieldDetailsData(String(this.areaId))!
    detailsContent = JSON.parse(detailsContent)

    this.showLoading = false
    this.showFieldItem = true
    // timestamp削除
    if (detailsContent !== null) {
      delete detailsContent[0]
    }

    if (this.item.planting.planting_id !== 0) {
      for (var i in detailsContent) {
        let result = {}

        if (this.item.planting.planting_id === detailsContent[i].planting_id) {
          // 欠損データがある場合
          if (detailsContent[i].max_intergration_temperature === 0) {
            this.showLackData = true
          } else {
            this.showLackData = false
          }

          result = detailsContent[i]
          this.maxIntegrationTemperature = detailsContent[i].max_intergration_temperature
          this.detailsData = result
          this.showNodata = false
        }

        if (detailsContent[i].planting_id === undefined) {
          this.showNodata = true
          // 初期値に戻す
          this.detailsData = {
            area_name: '-',
            earth_temperature: '-',
            field_id: 0,
            grade: '-',
            growth_status: '-',
            harvest_forecast_days: 0,
            image_path: require('@/assets/icon/ico_barley_02.svg'),
            intergration_temperature: 0,
            lat: '',
            lng: '',
            max_intergration_temperature: 0,
            ph: '-',
            planting_id: 0,
            excluded_area_rate: null,
            risk: {
              sickness: false,
              weeds: false,
              pest: false,
              human_problem: false,
              water_control: false
            },
            season: '-',
            variety_id: 0,
            variety_name: '-'
          }
        }
      }
    } else {
      this.showNodata = true
      // 初期値に戻す
      this.detailsData = {
        area_name: '-',
        earth_temperature: '-',
        field_id: 0,
        grade: '-',
        growth_status: '-',
        harvest_forecast_days: 0,
        image_path: require('@/assets/icon/ico_barley_02.svg'),
        intergration_temperature: 0,
        lat: '',
        lng: '',
        max_intergration_temperature: 0,
        ph: '-',
        planting_id: 0,
        excluded_area_rate: null,
        risk: {
          sickness: false,
          weeds: false,
          pest: false,
          human_problem: false,
          water_control: false
        },
        season: '-',
        variety_id: 0,
        variety_name: '-'
      }
      this.showFieldItem = true
      return
    }

    this.judgmentWorning()
    this.judgmentPhIcon()
    this.judgmentEarthIcon()
    this.progressMemori()
    this.displayExcludedArea()

    /* フラグリセット */
    this.$store.commit('setFlagState/setModalFieldDetailsDataFlag', false)
  }

  private setChoiceField (id: number) {
    this.$store.commit('fieldChoiceState/setChoosingModalFieldId', id)
    this.$store.commit('fieldChoiceState/setModalPlantingId', this.detailsData.planting_id)
  }

  private toggleLoading (flag: boolean) {
    this.showLoading = flag
  }

  private displayValue (value: number) {
    return value !== null && value !== undefined ? this.displayTranslation(value) : '-'
  }

  /* 小数点第一以下切り捨て表示 */
  private displayTranslation (num: number) {
    return Math.floor(num * 10) / 10
  }
}
